import React, { useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import toast from "../../utils/toast";

export default function ExportData() {
  const [profileId, setProfileId] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("adminToken");
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  const exportUserData = async () => {
    if (!profileId.trim()) {
      toast.showError("Please enter a profile ID");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${API_URL}/api/admin/user/export/${encodeURIComponent(profileId)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        let errorText = "User not found";
        try {
          const err = await response.json();
          errorText = err.message || errorText;
        } catch (e) {}
        throw new Error(errorText);
      }

      const result = await response.json();
      const userData = result.data || result;

      if (!userData) {
        toast.showError("No user data found for this profile ID");
        return;
      }

      const csvContent = generateCSV(userData);

      // Prepend UTF-8 BOM so Excel on Windows opens UTF-8 CSV correctly
      const bom = "\uFEFF";
      const blob = new Blob([bom + csvContent], { type: "text/csv;charset=utf-8;" });

      // IE10+ fallback
      if (navigator && navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, `user-export-${profileId}-${new Date().getTime()}.csv`);
      } else {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute(
          "download",
          `user-export-${profileId}-${new Date().getTime()}.csv`
        );
        link.style.visibility = "hidden";
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }

      toast.showSuccess(`Successfully exported data for user ${profileId}`);
      setProfileId("");
    } catch (error) {
      console.error("Export error:", error);
      toast.showError(error.message || "Failed to export user data");
    } finally {
      setLoading(false);
    }
  };

  const generateCSV = (userData) => {
  const escape = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    const s = val.toString();
    return s.includes(",") || s.includes("\n")
      ? `"${s.replace(/"/g, '""')}"`
      : s;
  };

  const nl = "\r\n";
  let csv = "User Export Report" + nl;
  csv += `Generated: ${new Date().toLocaleString()}` + nl + nl;

  // BASIC INFO
  csv += "=== BASIC INFORMATION ===" + nl;
  csv += `Profile ID,${escape(userData.profile_id)}` + nl;
  csv += `Name,${escape(userData.name)}` + nl;
  csv += `Email,${escape(userData.contact_email)}` + nl;
  csv += `Mobile,${escape(userData.mobile)}` + nl;
  csv += `Gender,${escape(userData.gender)}` + nl;
  csv += `DOB,${
    userData.dob
      ? new Date(userData.dob).toLocaleDateString("en-GB")
      : "-"
  }` + nl;
  csv += `Status,${escape(userData.status)}` + nl;
  csv += `Created,${
    userData.createdAt
      ? new Date(userData.createdAt).toLocaleString("en-GB")
      : "-"
  }` + nl + nl;

  // PROFILE DETAILS
  csv += "=== PROFILE DETAILS ===" + nl;
  csv += `Religion,${escape(userData.religion?.name)}` + nl;
  csv += `Caste,${escape(userData.caste?.name)}` + nl;
  csv += `Complexion,${escape(userData.complexion?.name)}` + nl;
  csv += `Marital Status,${escape(userData.marital_status?.name)}` + nl;
  csv += `Height,${escape(userData.height)}` + nl;
  csv += `Weight,${escape(userData.weight)}` + nl;
  csv += `Blood Group,${escape(userData.blood_group)}` + nl;
  csv += `Manglik,${escape(userData.manglik)}` + nl;
  csv += `Dosh,${escape(userData.dosh)}` + nl + nl;

  // LOCATION
  csv += "=== LOCATION ===" + nl;
  csv += `State,${escape(userData.loc_state?.name)}` + nl;
  csv += `City,${escape(userData.loc_city?.name)}` + nl;
  csv += `Pincode,${escape(userData.loc_pincode)}` + nl;
  csv += `Residence Type,${escape(userData.loc_residence_type)}` + nl;
  csv += `House Type,${escape(userData.loc_house_type)}` + nl + nl;

  // ADDITIONAL
  csv += "=== ADDITIONAL INFORMATION ===" + nl;
  csv += `About,${escape(userData.about)}` + nl;
  csv += `Health Info,${escape(userData.health_information)}` + nl;
  csv += `Disability,${escape(userData.disability)}` + nl;

  const hobbiesList =
    userData.hobbies?.map((h) => h.name).join("; ") || "-";
  csv += `Hobbies,${escape(hobbiesList)}` + nl;

  csv += `Diet,${escape(userData.diet?.name)}` + nl;
  csv += `Profile For,${escape(userData.profile_for?.name)}` + nl;
  csv += `Reference,${escape(userData.reference)}` + nl + nl;

  // FAMILY
  csv += "=== FAMILY INFORMATION ===" + nl;
  csv += `Family Type,${escape(userData.family_type)}` + nl;
  csv += `Family Value,${escape(userData.family_value)}` + nl;
  csv += `No of Brother,${escape(userData.no_of_brother)}` + nl;
  csv += `No of Sister,${escape(userData.no_of_sister)}` + nl;

  return csv;
};

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Export Data" />

        <div className="right_col" role="main">
          

          <div className="clearfix" />

          <div className="x_panel">
            <div className="x_title">
              <h2>Export Data</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>
              </ul>
              <div className="clearfix" />
            </div>

            <div className="x_content">
              <div className="row">
                <div className="col-sm-12">
                  <div className="filtercont pr-lg-2">
                    <div className="row">
                      <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                        <label>Profile ID</label>
                        <input
                          type="text"
                          className="form-control"
                          value={profileId}
                          onChange={(e) => setProfileId(e.target.value)}
                          placeholder="Enter profile ID (e.g., VIV001)"
                        />
                      </div>

                      <div className="col-12 col-sm-2">
                        <label>&nbsp;</label>
                        <button
                          onClick={exportUserData}
                          disabled={loading || !profileId.trim()}
                          className="btn sitebtn"
                          style={{ width: "100%" }}
                        >
                          {loading ? "Exporting..." : "Export"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
